module.exports = __webpack_public_path__ + "img/trial1-2.b0c1f636.png";